export default __webpack_public_path__ + "static/media/affects-body.9d931f52.jpg";